import BaseModal from 'components/modals/BaseModal';
import { QRCodeSVG } from 'qrcode.react';
import React, { useState } from 'react';
import { ContentProps } from './QRcodeModal.interface';
import * as S from './QRcodeModal.styles';
const Content = ({ open, closeModal, QRcode }: ContentProps) => {
  const [value, setValue] = useState(QRcode);

  if (!QRcode) return null;

  return (
    <S.QRcodeModal>
      <QRCodeSVG
        value={value}
        size={256}
        bgColor={'#ffffff'}
        fgColor={'#000000'}
        level={'H'}
        includeMargin={false}
        imageSettings={{
          src: '/passenger/images/static/logo-blue-iranair.png',
          x: undefined,
          y: undefined,
          height: 80,
          width: 80,
          excavate: true,
        }}
      />
    </S.QRcodeModal>
  );
};

interface State {
  open: boolean;
  QRcode: string;
}

interface Props {
  ref: any;
}

class ModalQR extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      QRcode: '',
    };
  }

  openModal = (QRcode: string): void => this.setState({ open: true, QRcode });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.QRcodeContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.QRcode ? (
          <Content {...this.props} open={this.state.open} closeModal={this.closeModal} QRcode={this.state.QRcode} />
        ) : null}
      </S.QRcodeContainer>
    );
  }
}

export default ModalQR;
